export type Insurance = {
  id: string;
  payor: number;
  name?: string;
  active: 0 | 1;
  patientId: string;
  clinicId: number;
  createdAt: number;
  updatedAt: number;
  internalName?: string;
  type: PatientInsuranceTypes;
  insuranceTypeCode?: string;
  memberId: string;
  planGroupId?: string;
  primaryInsuredType?: PrimaryInsuredTypes;
  primaryInsured?: PatientPrimaryInsured;
  insuranceFront?: string;
  insuranceBack?: string;
  payorDescription?: { payorID: string; legalName: string };
  policyEndDate?: string | number | null;
  policyMaximum?: number;
  deductible?: number;
  adjustorInformation?: AdjustorInformation;
  acceptAssignment?: boolean;
  signatureOnFile?: boolean;
  releaseOfPatientInformation?: boolean;
  disciplineBenefits?: DisciplineInsuranceBenefit[];
  propertyAndCasualtyInsurance?: PropertyAndCasualtyInsurance;
  legalName?: string;
  inNetwork?: boolean;
  payorID?: string;
};

export type HealthcomInsurance = {
  id: string;
  payor?: number;
  name?: string;
  active: 0 | 1;
  patientId: string;
  clinicId: number;
  createdAt: number;
  updatedAt: number;
  type: PatientInsuranceTypes | PatientInsuranceTypesSpanish;
  memberId: string;
  planGroupId?: string;
  primaryInsuredType?:
    | PrimaryInsuredTypes
    | PrimaryInsuredTypesSurvey
    | PrimaryInsuredTypesSpanishSurvey;
  primaryInsured?: PatientPrimaryInsured;
  insuranceFront?: string;
  insuranceBack?: string;
  clinicIdPatientId: string;
  insuranceFrontPreview?: string | null;
  insuranceBackPreview?: string | null;
};

export enum PatientInsuranceTypes {
  Primary = 'primary',
  Secondary = 'secondary',
  Other = 'other',
}

export enum PatientInsuranceTypesSpanish {
  Primario = 'primary',
  Secundario = 'secondary',
  Otro = 'other',
}

export enum PrimaryInsuredTypesSurvey {
  Self = 'patient',
  Spouse = 'spouse',
  Child = 'parent',
  Employee = 'employer',
  Other = 'other',
}

export enum PrimaryInsuredTypesSpanishSurvey {
  'Mi persona' = 'patient',
  Pareja = 'spouse',
  'Padre/Madre' = 'parent',
  Empleado = 'employer',
  Otro = 'other',
}

export enum PrimaryInsuredTypes {
  Patient = 'patient',
  Spouse = 'spouse',
  Parent = 'parent',
  Employer = 'employer',
  Other = 'other',
}

export const PrimaryInsuredTypeEdiCode = {
  [PrimaryInsuredTypes.Patient]: '18',
  [PrimaryInsuredTypes.Spouse]: '01',
  [PrimaryInsuredTypes.Parent]: '19',
  [PrimaryInsuredTypes.Employer]: '20',
  [PrimaryInsuredTypes.Other]: 'G8',
  _unknown: '21',
};

export type PatientPrimaryInsured = {
  fname?: string;
  mname?: string;
  lname?: string;
  suffix?: string;
  dateOfBirth?: string;
  sex?: InsuranceSexTypes | InsuranceSexTypesSpanish;
  addressSameAsPatient?: boolean;
  streetAddress?: string;
  address2?: string;
  city?: string;
  state?: string;
  country?: string;
  postalCode?: string;
  phone?: string;
  countrty?: string;
};

export type DisciplineInsuranceBenefit = {
  disciplineId: number;
  maxNumberOfTreatments?: number;
  coPay?: number;
  coPayExempt?: boolean;
  coInsurance?: number;
  priorAuthorization?: PriorAuthorization;
  referralNumber?: string;
};

export type PriorAuthorization = {
  number?: string;
  validStartDate?: string | number | null;
  validEndDate?: string | number | null;
  numberOfUses?: number;
};

export type AdjustorInformation = {
  name?: string;
  phone?: string;
  extension?: string;
  email?: string;
};

export type PropertyAndCasualtyInsurance = {
  claimNumber?: string;
  contactName?: string;
  claimContactPhone?: string;
  extension?: string;
  claimContactExtension?: string; // TODO: Implement this in the UI.
  patientIdType?: string;
  ssn?: string;
  memberId?: string;
};

export enum InsuranceSexTypes {
  Male = 'male',
  Female = 'female',
  X = 'x',
}

export enum InsuranceSexTypesSpanish {
  Masculino = 'male',
  Femenino = 'female',
  X = 'x',
}
